export const locations = [
  {
    type: "Tour",
    name: "One Way Tour",
    description: "verschiedene Touren",
    image: "./assets/onewaytour.png",
    website: "https://onewaytour.com/",
    googleMaps: "https://maps.app.goo.gl/5BfxdkmrgqFQaRLx9",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.0775455657977!2d44.50816087623746!3d40.185087669704984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abcfad576ef49%3A0xaa6a4c2e17129a46!2sONE%20WAY%20TOUR!5e0!3m2!1sen!2sch!4v1737988412658!5m2!1sen!2sch",
    must: false,
  },
  {
    type: "Tour",
    name: "Hyur Service",
    description: "verschiedene Touren (mehrere Standorte)",
    image: "./assets/hyur.png",
    website: "https://hyurservice.com/en",
    googleMaps: "https://maps.app.goo.gl/WSYH4MQTP4y9EehHA",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.276661086783!2d44.51639967623718!3d40.18065606997344!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abce53b14370f%3A0x57815c2dd9d4bbc8!2sHyur%20Service!5e0!3m2!1sen!2sch!4v1737989390221!5m2!1sen!2sch",
    must: false,
  },
   {
    type: "Tour",
    name: "Get Your Guide",
    description: "verschiedene Touren (mehrere Standorte)",
    image: "./assets/getyourguide.png",
    website: "https://www.getyourguide.com/-l169060/?cmp=ga&cq_src=google_ads&cq_cmp=16370954064&cq_con=139000796372&cq_term=armenia%20trips&cq_med=&cq_plac=&cq_net=g&cq_pos=&cq_plt=gp&campaign_id=16370954064&adgroup_id=139000796372&target_id=kwd-793967528&loc_physical_ms=9070053&match_type=e&ad_id=586388894879&keyword=armenia%20trips&ad_position=&feed_item_id=&placement=&device=c&partner_id=CD951&gad_source=1&gad_campaignid=16370954064&gbraid=0AAAAADmzJCMFe0roof41L4azXY0y0uXY5&gclid=Cj0KCQjwnJfEBhCzARIsAIMtfKKZLi8WXyBv_YGbGGJ5X5LRZZFrOgvpgskHmkAJhKC6jSkAbziMa0EaAlaxEALw_wcB",
    googleMaps: "",
    embed: "",
    must: false,
  },
  {
    type: "Tour",
    name: "Liste mit...",
    description: "Tour Agencies, Aktivitäten und mehr auf Tripadvisor",
    image: "./assets/tripadvisor.png",
    website:
      "https://www.tripadvisor.com/Attractions-g293932-Activities-c42-a_attractionType.SUPPLIERS-Yerevan.html",
    googleMaps: "",
    embed: "",
    must: false,
  },
  {
    type: "Restaurant",
    name: "Sherep",
    description: "Live Musik abends zwischen 20.00-23.00 Uhr.",
    image: "./assets/sherep.jpeg",
    website:
      "https://www.tripadvisor.co.uk/Restaurant_Review-g293932-d13157535-Reviews-Sherep_Restaurant-Yerevan.html",
    googleMaps: "https://maps.app.goo.gl/uCgkz1Tzad4TDBJD7",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.3759873751937!2d44.508434676237144!3d40.17844527010734!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abcf963d1253f%3A0x45731d07b927e010!2zU2hlcmVwIFJlc3RhdXJhbnQgKCDVh9Wl1oDVpdaDINW81aXVvdW_1bjWgNWh1bYgKQ!5e0!3m2!1sen!2sch!4v1737896953859!5m2!1sen!2sch",
    must: false,
  },
  {
    type: "Restaurant",
    name: "Lavash",
    description: "Vorallem für reiches armenisches Frühstück bekannt",
    image: "./assets/lavash.jpg",
    website:
      "https://www.yeremyanprojects.com/en/restaurants/lavash",
    googleMaps: "https://maps.app.goo.gl/wMf2PBQnSZZsq8V4A",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.1695796025006!2d44.51370707709414!3d40.18303937147818!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abce36330584b%3A0xf87bea155165fdac!2sLavash%20Restaurant!5e0!3m2!1sen!2sam!4v1753604772505!5m2!1sen!2sam",
    must: false,
  },
  {
    type: "Restaurant",
    name: "Seasons",
    description: "Eher europäisch",
    image: "./assets/seasons.jpg",
    website:
      "https://www.tripadvisor.in/Restaurant_Review-g293932-d17639706-Reviews-Seasons_Restaurant-Yerevan.html",
    googleMaps: "https://maps.app.goo.gl/tSon86oFJVEyWK6C9",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.1903781360393!2d44.50621947623731!3d40.18257646985717!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abd4538b30399%3A0xa34934c3e4cdef14!2sSeasons%20Restaurant!5e0!3m2!1sen!2sch!4v1737896695885!5m2!1sen!2sch",
    must: false,
  },
  {
    type: "Restaurant",
    name: "Tavern Yerevan",
    description: "abends Live Musik & Tanz",

    image: "./assets/tavern_yerevan.jpg",
    website:
      "https://www.tripadvisor.in/Restaurant_Review-g293932-d8800809-Reviews-Tavern_Yerevan-Yerevan.html",
    googleMaps: "https://maps.app.goo.gl/PHsi5ZUaHKyu5Xqh7",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3047.9068702349905!2d44.51874697623757!3d40.18888596947487!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abcdfdf97b7c5%3A0x9a4db6fc885df263!2zVGF2ZXJuIFllcmV2YW4gKFRlcnlhbikg1YrVodW21aTVuNWvINS11oDWh9Wh1bYgKNWP1aXWgNW11aHVtik!5e0!3m2!1sen!2sch!4v1737896753943!5m2!1sen!2sch",
    must: false,
  },
  {
    type: "Restaurant",
    name: "Kamancha",
    description: "abends Live Musik & Tanz",

    image: "./assets/kamancha.jpg",
    website:
      "https://www.tripadvisor.com/Restaurant_Review-g293932-d18980030-Reviews-Kamancha_Restaurant-Yerevan.html",
    googleMaps: "https://maps.app.goo.gl/rTTed2f1RhUJsk6j6",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.129733144513!2d44.514140999999995!3d40.1839262!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abdc6a552cd6f%3A0xb6e7edd4eaf7d3a7!2sKamancha!5e0!3m2!1sen!2sch!4v1737899404930!5m2!1sen!2sch",
    must: false,
  },
  {
    type: "Restaurant",
    name: "Tumanyan Shaurma",
    description: "Viele Standorte in Yerevan verteilt. Wie 'Dürüm' :)",

    image: "./assets/tumanyanshaurma.jpg",
    website:
      "https://www.tumanyanshaurma.am",
    googleMaps: "https://maps.app.goo.gl/QU3VyoGQBhCtcjK89",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7100.626234704741!2d44.51499080430148!3d40.1828977072906!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abce37c22b149%3A0x53b14b76c0e437c6!2sTumanyan%20Shaurma!5e0!3m2!1sen!2sam!4v1753605137351!5m2!1sen!2sam",
    must: false,
  },

  {
    type: "Sehenswürdigkeit",
    name: "Republic Square",
    description: "Tanzende Fontänen ab 21 Uhr ",
    image: "./assets/republic_square.jpg",
    website:
      "https://www.tripadvisor.com/Attraction_Review-g293932-d2045366-Reviews-Republic_Square-Yerevan.html",
    googleMaps: "https://maps.app.goo.gl/v2pD3d4DvQYFSSjB7",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.410031245189!2d44.5126406!3d40.1776875!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abcfa28499691%3A0x2bde14d127166c74!2sRepublic%20Square!5e0!3m2!1sen!2sch!4v1737897621244!5m2!1sen!2sch",
    must: true,
  },
  {
    type: "Sehenswürdigkeit",
    name: "Northern Avenue",
    description: "Flanieren, Shoppen, Kaffee trinken...",
    image: "./assets/northern_ave.jpeg",
    website:
      "https://www.tripadvisor.com/Attraction_Review-g293932-d8564150-Reviews-Northern_Avenue-Yerevan.html",
    googleMaps: "https://maps.app.goo.gl/SQz59DWQGhAWzBzs9",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.246274186285!2d44.514587199999994!3d40.181332399999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abce3504f4edd%3A0x120a99b9487840ea!2sHyusisayin%20poghota%2C%20Yerevan%2C%20Armenia!5e0!3m2!1sen!2sch!4v1737897749912!5m2!1sen!2sch",
    must: true,
  },
  {
    type: "Sehenswürdigkeit",
    name: "Kaskade",
    description:
      "Schöner Park, Kaffees und Treppenkomplex mit 572 Stufen (Es gibt Rolltreppen) und allerbester Aussicht",
    image: "./assets/cascade.jpg",
    website: "https://www.cmf.am/The-Cascade-Complex",
    googleMaps: "https://maps.app.goo.gl/B6zBANg4i5asAbEQ8",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3047.806905668001!2d44.510750988148864!3d40.191110495807365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abd218c0499f7%3A0x54165e8b3d0b54c3!2sCascade%20Complex!5e0!3m2!1sen!2sch!4v1737897581385!5m2!1sen!2sch",
    must: true,
  },
  {
    type: "Sehenswürdigkeit",
    name: "Vernissage",
    description: "Perfekt für Mitbringsel",
    image: "./assets/vernissage.jpg",
    website:
      "https://www.tripadvisor.com/Attraction_Review-g293932-d2422703-Reviews-Vernissage_Market-Yerevan.html",
    googleMaps: "https://maps.app.goo.gl/isr77cU8jNwqzrhN7",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12192.757916826207!2d44.49849466759782!3d40.1825964769322!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abcfa72380a91%3A0xb22f51c82a235ca7!2sVernissage%20Market!5e0!3m2!1sen!2sch!4v1737900199289!5m2!1sen!2sch",
    must: true,
  },
  {
    type: "Sehenswürdigkeit",
    name: "Garni Temple",
    description: "Tempel aus dem 1. Jahrhundert",

    image: "./assets/garni.jpg",
    website: "https://en.wikipedia.org/wiki/Temple_of_Garni",
    googleMaps: "https://maps.app.goo.gl/8tCAEXB8ghHv4bY18",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8511.107750848409!2d44.7214860975098!3d40.11695045838617!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406aae215bde05e5%3A0x3326a533973fd65f!2sGreco-Roman%20Sun%20temple%20in%20Garni!5e0!3m2!1sen!2sch!4v1737897028352!5m2!1sen!2sch",
    must: true,
  },
  {
    type: "Sehenswürdigkeit",
    name: "Geghard Monastery",
    description: "Felsenkirche - gebaut im Felsen drin",

    image: "./assets/geghard.jpg",
    website: "https://en.wikipedia.org/wiki/Geghard",
    googleMaps: "https://maps.app.goo.gl/1LhCiwSgyi94Giqb7",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3050.082532625811!2d44.81595497623563!3d40.14044527240825!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406aaead91206219%3A0x4003cbe690889756!2sGeghard!5e0!3m2!1sen!2sch!4v1737897162678!5m2!1sen!2sch",
    must: true,
  },
  {
    type: "Sehenswürdigkeit",
    name: "Matenadaran",
    description: "Zentralarchiv für alte Manuskripte",
    image: "./assets/matenadaran.jpg",
    website: "",
    googleMaps: "https://maps.app.goo.gl/ap4zGyCkEmWj7upCA",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3047.769718748258!2d44.5159856881493!3d40.19193799575667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abd20f0977ad9%3A0x7f2158e0bb6e6dd7!2sMatenadaran!5e0!3m2!1sen!2sch!4v1737897398502!5m2!1sen!2sch",
    must: false,
  },
  {
    type: "Sehenswürdigkeit",
    name: "Tsitsernakaberd",
    description: "Denkmalkomplex zum Gedenken der Opfer des Völkermords",
    image: "./assets/cicernakaberd.jpg",
    website: "https://www.genocide-museum.am/eng/Description_and_history.php",
    googleMaps: "https://maps.app.goo.gl/Mz73ARUhuK2xEwQH7",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d782794.6559611235!2d44.700735512499975!3d39.9684112972433!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abd086306aa15%3A0x26bea23bec8c6762!2sTsitsernakaberd%20Armenian%20Genocide%20Memorial%20Complex!5e0!3m2!1sen!2sch!4v1737899937020!5m2!1sen!2sch",
    must: true,
  },
  {
    type: "Sehenswürdigkeit",
    name: "Mutterkirche des heiligen Etschmiadsin",
    description: "ältester christlicher Ort der Armenier",
    image: "./assets/mayrator.jpg",
    website: "https://www.armenianchurch.org/en",
    googleMaps: "https://maps.app.goo.gl/GuFVaF5oLCRYtajr6",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6097.990155401954!2d44.28325712528107!3d40.16466190644081!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406a94d41e90d379%3A0xb40e651e0e7dec5f!2sMother%20See%20of%20Holy%20Etchmiadzin%20-%20Armenian%20Apostolic%20Church%20(Armenian%20Orthodox%20Church)!5e0!3m2!1sen!2sch!4v1737899977181!5m2!1sen!2sch",
    must: false,
  },
  {
    type: "Sehenswürdigkeit",
    name: "Opernhaus",
    description: "Besuche Theater, Tanz, Konzerte & mehr zu günstigen Preisen.",
    image: "./assets/opera.jpg",
    website: "https://www.opera.am/public/en",
    googleMaps: "https://maps.app.goo.gl/xmFTi4GALCSGZFbn7",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.042735769725!2d44.51250567623726!3d40.1858623696581!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abce217b8839d%3A0x80bc65ebce1f70f!2sArmenian%20National%20Opera%20and%20Ballet%20Theatre!5e0!3m2!1sen!2sch!4v1737901332052!5m2!1sen!2sch",
    must: true,
  },
  {
    type: "Sehenswürdigkeit",
    name: "Tatev Monastery",
    description:
      "+ Hinreise mit der längsten Seilbahn der Welt, 5.75km! Gebaut von Schweizern :)",
    image: "./assets/tatev.jpg",
    website:
      "https://www.tripadvisor.com/Attraction_Review-g815352-d1128729-Reviews-Tatev_Monastery-Tatev_Syunik_Province.html",
    googleMaps: "https://maps.app.goo.gl/eHUCKEnypAdnrRYG9",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6167.575594789455!2d46.23742099613082!3d39.38367967898853!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x401606656a198faf%3A0xeef9e3e00882096!2sTatev%20Monastery!5e0!3m2!1sen!2sch!4v1737897324091!5m2!1sen!2sch",
    must: true,
  },
  {
    type: "Sehenswürdigkeit",
    name: "Khndzoresk",
    description: "Schwingende Brücke, Höhlenstadt",
    image: "./assets/khndzoresk.jpg",
    website:
      "https://www.tripadvisor.com/Attraction_Review-g2707298-d4355179-Reviews-Old_Khndzoresk-Syunik_Province.html",
    googleMaps: "https://maps.app.goo.gl/3eRveAUVaMwUrQRQ8",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12312.295496231463!2d46.41962886722813!3d39.5128223498771!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x403dfdc283be9e01%3A0xc5dd42777005384f!2sKhndzoresk%2C%20Armenia!5e0!3m2!1sen!2sch!4v1737897446415!5m2!1sen!2sch",
    must: false,
  },
  {
    type: "Sehenswürdigkeit",
    name: "Sevan",
    description: "See auf 1900m Höhe",
    image: "./assets/sevan.jpg",
    website:
      "https://www.tripadvisor.com/Attraction_Review-g666442-d19253696-Reviews-Lake_Sevan-Sevan_Lake_Sevan_Gegharkunik_Province.html",
    googleMaps: "https://maps.app.goo.gl/Hr5q4fmVWtexSkcY6",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d97009.2259961575!2d44.81818995480816!3d40.55178818940162!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x404046c39477eb71%3A0xeb5b902ad8d28d76!2sSevan%2C%20Armenia!5e0!3m2!1sen!2sch!4v1737897534317!5m2!1sen!2sch",
    must: true,
  },

  {
    type: "Sehenswürdigkeit",
    name: "Khor Virap Monastery",
    description:
      "Symbol für die Verbreitung des christlichen Glaubens. Am Fusse des Berges Ararat",
    image: "./assets/khor_virap.jpg",
    website: "https://en.wikipedia.org/wiki/Khor_Virap",
    googleMaps: "https://maps.app.goo.gl/TCgsKDo6huamKbhs9",
    embed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3061.8124402976405!2d44.57355167622504!3d39.87843898822533!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4015325d369f0d4b%3A0xeba04cad0e28a010!2sKhor%20Virap%20Monastery!5e0!3m2!1sen!2sch!4v1737897702301!5m2!1sen!2sch",
    must: true,
  },
];
